export enum Grid {
  TwoColumns = 'twoColumns',
  ThreeColumns = 'threeColumns',
}

export type TargetType = '_blank' | '_self';

export type CardProps = {
  title: string;
  slug: string;
  text?: string;
  tags?: string[];
  target?: TargetType;
};

export type DocumentationProps = {
  id?: string;
  title: string;
  cards: CardProps[];
  grid?: Grid;
  description?: string;
  className?: string;
};
